import React, { useState, useEffect } from "react";
import {
	Col,
	Row,
	Card,
	CardBody,
	Modal,
	ModalBody,
	ModalHeader,
	List,
	CardText,
	Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Website/AuthService";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { authenticate } from "store/Auth/actions";
import { useTranslation } from "react-i18next";

const CallModal = ({ modal, setModal, callTypeModal, phone }) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);

	return (
		<Modal
			isOpen={modal}
			toggle={() => setModal(false)}
			style={{ maxWidth: "600px", marginTop: "10%", width: "100%" }}
			className={`message-modal ${AuthData.lang !== "ar" ? "" : "ar-wrapper"}`}>
			<ModalBody className="m-0 p-0 fw-bold">
				<div
					className="overflow-hidden m-0 p-0"
					style={{ direction: "inherit" }}>
					<div className="p-0 m-0">
						<p
							style={{ fontSize: "32px" }}
							className="mb-1 text-center bask-font text-primary">
							{t("Let us get in touch with you")}
						</p>
						<p className="text-primary subtitle text-center m-auto fw-300">
							{t("ADD YOUR NUMBER AND EMAIL OUR TEAM WILL CONTACT YOU SHORTLY")}
						</p>
						<p className="mt-4 mb-0 fw-bold font-size-24 text-color text-center">
							{phone}
						</p>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};
export default CallModal;
